export default __webpack_public_path__ + "static/media/project1.30034fdd.png";